import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { forwardRef } from 'react';
import cn from 'classnames';
import Card from '@ebsco-ui/card';
import { createGenericContext, createBemBlockBuilder } from '@ebsco-ui/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { jsx, jsxs } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _createGenericContext = createGenericContext({
  errorMessage: "InPageNotification compound components cannot be rendered outside of the InPageNotification component"
}),
    useInPageContext = _createGenericContext.useGenericContext;
    _createGenericContext.GenericContextConsumer;
    var InPageContextProvider = _createGenericContext.GenericContextProvider;

var _excluded$1 = ["children", "className"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var InPageHeader = function InPageHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  var _useInPageContext = useInPageContext(),
      getBlocksWith = _useInPageContext.getBlocksWith;

  return /*#__PURE__*/jsx("h2", _objectSpread$1(_objectSpread$1({}, rest), {}, {
    className: cn(className, getBlocksWith("__header")),
    children: children
  }));
};

var _excluded = ["children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var InPageDescription = function InPageDescription(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useInPageContext = useInPageContext(),
      getBlocksWith = _useInPageContext.getBlocksWith;

  return /*#__PURE__*/jsx("p", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(className, getBlocksWith("__description")),
    children: children
  }));
};

var ICONS = {
  default: faExclamationCircle,
  error: faExclamationCircle,
  information: faExclamationCircle,
  success: faCheckCircle,
  warning: faExclamationTriangle
};
var VARIANT;

(function (VARIANT) {
  VARIANT["error"] = "error";
  VARIANT["information"] = "information";
  VARIANT["success"] = "success";
  VARIANT["warning"] = "warning";
})(VARIANT || (VARIANT = {}));

var InPageNotification = forwardRef(function (_ref, ref) {
  var _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? "" : _ref$ariaLabel,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? [] : _ref$children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      variant = _ref.variant,
      icon = _ref.icon;
  var faIcon = icon || ICONS[variant] || ICONS.default;
  var getBlocksWith = createBemBlockBuilder(["eb-in-page-notification", className]);
  var inPageContext = {
    getBlocksWith: getBlocksWith
  };
  return /*#__PURE__*/jsx(InPageContextProvider, {
    value: inPageContext,
    children: /*#__PURE__*/jsxs(Card, {
      ariaLabel: ariaLabel || variant,
      border: "all",
      className: cn(getBlocksWith(), getBlocksWith("--".concat(variant))),
      isRounded: true,
      isTransparent: false,
      ref: ref,
      children: [/*#__PURE__*/jsx(FontAwesomeIcon, {
        "data-auto": "font-awesome-icon",
        className: getBlocksWith("__icon"),
        icon: faIcon
      }), /*#__PURE__*/jsx("div", {
        "data-auto": "content",
        className: getBlocksWith("__content"),
        children: children
      })]
    })
  });
});
InPageNotification.displayName = "InPageNotification";
InPageNotification.ICONS = ICONS;
InPageNotification.VARIANT = VARIANT;
InPageNotification.Header = InPageHeader;
InPageNotification.Header.displayName = "InPageNotification.Header";
InPageNotification.Description = InPageDescription;
InPageNotification.Description.displayName = "InPageNotification.Description";

export { InPageNotification as default };
//# sourceMappingURL=in-page-notification-esm.js.map
